<template>
    <Dropdown placement="bottom-end" class="QHSelectBtn">
        <Button :type="type" size="small" :icon="icon">{{ title}}</Button>
        <DropdownMenu slot="list" class="DropdownMenu">
            <slot></slot>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
export default {
    name: 'QHset',
    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        title: {
            type: String,
            default: "操作"
        },
        type: {
            type: String,
            default: "info"
        },
        icon: {
            type: String,
            default: "ios-settings"
        },
    },
};
</script>
<style>
.QHSelectBtn .DropdownMenu {
    min-width: auto;
}

.QHSelectBtn .ivu-select-dropdown {
    padding: 0;
}

.QHSelectBtn .DropdownMenu button {
    display: block;
    margin: 5px !important;
}
</style>